export type ActivePlaybackRange = {
  startFrame: number;
  endFrame: number;
};

export function buildActivePlaybackRanges(
  clips: ReadonlyArray<{ startFrame: number; durationFrames: number }>,
): ActivePlaybackRange[] {
  return clips.map((clip) => ({
    startFrame: clip.startFrame,
    endFrame: clip.startFrame + clip.durationFrames,
  }));
}

/** Half-open interval ownership: [startFrame, endFrame). */
export function isTimelineFrameWithinActivePlaybackRanges(
  frame: number,
  ranges: ReadonlyArray<ActivePlaybackRange>,
): boolean {
  if (!ranges.length || !Number.isFinite(frame)) {
    return false;
  }

  const timelineFrame = Math.round(frame);
  return ranges.some(
    (range) =>
      timelineFrame >= range.startFrame && timelineFrame < range.endFrame,
  );
}
